import Instance from "../../../../Axios";

// New Actions for the app

const GetTempoMedioResposta =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/tempoMedioResposta`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_TEMPO_MEDIO_RESPOSTA",
          payload: data.yData[0].tempoMedio,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetTempoMedioResposta;
